import { defineStore } from "pinia";
import { ref } from "vue";
import { useBase } from "@/utils/stores/base";

const storeName = "company";

export const useCompanyStore = defineStore(storeName, () => {
  const all = ref([]);

  const {
    baseFetchOne,
    baseFetchAll,
    baseMultipartSave,
    watchRemoteResourceChange,
    basePost,
    baseDelete,
  } = useBase(storeName);

  const buildEmpty = () => ({
    attributes: {},
    relationships: {
      companyUltimateBeneficialOwners: { data: [] },
      signatories: { data: [] },
      companyDocuments: { data: [] },
    },
  });

  const path = "companies";

  const save = async (resource, callback, errorCallback) => {
    return await baseMultipartSave(path, resource, callback, errorCallback);
  };

  const fetchAll = async (errorCallback, includes = []) => {
    all.value = await baseFetchAll(path, errorCallback, includes, { paginate: true, perPage: 50 });
  };

  const fetchOne = async (id, extended, errorCallback, includes = []) => {
    return await baseFetchOne(path, id, errorCallback, includes, { extended });
  };

  const prefillCompany = async (companyNumber, callback, errorCallback) => {
    const isValidFormat = /^(BE)?\d{4}(\.\d{3}\.\d{3}|\d{6})$/.test(companyNumber);

    if (!isValidFormat) {
      return;
    }
    await basePost("company-prefill", { companyNumber: companyNumber }, callback, errorCallback);
  };

  const buildReport = async (companyId, callback, errorCallback, includes = []) => {
    const path = `companies/${companyId}/reports/companies`;
    const params = {};
    if (includes && includes.length > 0) {
      params.include = Array.isArray(includes) ? includes.join(",") : includes;
    }
    return await basePost(path, {}, callback, errorCallback, params);
  };

  const deleteReport = async (companyReportId, companyId, callback, errorCallback) => {
    const path = `companies/${companyId}/reports/companies`;
    return await baseDelete(path, companyReportId, callback, errorCallback);
  };

  const watchResourceChanges = async (callback) => {
    await watchRemoteResourceChange(storeName, callback);
  };

  return {
    saveCompany: save,
    fetchCompanies: fetchAll,
    fetchCompany: fetchOne,
    prefillCompany,
    companies: all,
    emptyCompany: buildEmpty,
    buildReport,
    deleteReport,
    watchResourceChanges,
  };
});
